<template>
  <div class="content no-flex active">
    <ed-section
      title=" "
      class="no-flex active no-margin no-border"
      wide
      full-width
    >
      <ed-form
        :submit-visible='false'
      >
        <br />
        <div class="col-md-5 col-md-offset-7 no-pad">
          <ed-select
            field-label='Paid By'
            placeholder='Select Paid By'
            v-if="model.DisplayPaidBy"
            :options='paidByOptions'
            v-model='paidBy'
            required
            label='Value'
            track-by='Value'
            @select='paidByChanged'
            helptipHeader=''
            :error='errors.PaidByMissing'
            :helptip-body='errors.PaidByMissing && "Please enter Paid By." || ""'
            name='paid_by'
          ></ed-select>

          <ed-select
            field-label='Payment Method'
            placeholder='Select Payment Method'
            :options='paymentMethods'
            v-model='paymentMethod'
            required
            label='Value'
            track-by='Value'
            @select='paymentMethodChanged'
            helptipHeader=''
            :error='errors.PaymentMethodMissing'
            :helptip-body='errors.PaymentMethodMissing && "Please select a Payment Method." || ""'
            name='post_payment_method'
          ></ed-select>

          <ed-select
            field-label='Cost Center'
            placeholder='Select Cost Center'
            v-if="displayCostCenters"
            :options='model.CostCenters'
            v-model='costCenter'
            required
            label='Value'
            track-by='Value'
            @select='costCenterChanged'
            helptipHeader=''
            :error='errors.CostCenterMissing'
            :helptip-body='errors.CostCenterMissing && "Please select a Cost Center." || ""'
            name='post_payment_cost_center'
          ></ed-select>

          <ed-input
            field-label='Reference Number'
            v-model='referenceNo'
            required
            @input='emitChanges'
            helptipHeader=''
            :error='errors.ReferenceNoMissing'
            :helptip-body='errors.ReferenceNoMissing && "Please enter a Reference Number." || ""'
            name='post_payment_reference_no'
          />

          <ed-upload
            :class='{ loading: !uploadFinished }'
            field-label='Attachment'
            button-label='Browse'
            :data='uploadData'
            readonly
            :multiple='false'
            :postAction='api.env + api.$.upload.uploadInvoice'
            :uploadAuto='true'
            @input='saveAttachment'
            name='post_payment_attachment_upload'
          ></ed-upload>

          <ed-textarea
            field-label='Payment Notes'
            v-model='paymentNotes'
            :max-length='150'
            @input='emitChanges'
            name='post_payment_notes'
          />

        </div>
      </ed-form>
      <div class="clear"></div>
    </ed-section>
  </div>
</template>

<script>
/* eslint spec-file: 0 */

import { Eved, EventBus } from '@/event-bus'

export default {
  props: {
    divisionKey: Number,
    model: Object,
    paymentMethods: Object,
    userToken: String
  },

  created() {
    this.$nextTick(() => {
      this.selectFirstCostCenter()

      this.initEvents()
    })
  },

  activated() {
    this.errors.PaidByMissing = false
    this.errors.PaymentMethodMissing = false
    this.errors.ReferenceNoMissing = false
    this.errors.CostCenterMissing = false

    this.initEvents()
  },

  deactivated() {
    this.paidBy = {}
    this.paymentMethod = {}
    this.costCenter = {}
    this.attachment = {}
    this.referenceNo = ''
    this.paymentNotes = ''
  },

  computed: {
    displayCostCenters() {
      return this.model.CostCenters.length > 0 && this.isCreditCardMethod
    },
    isCreditCardMethod() {
      return this.paymentMethod && this.paymentMethod.Value &&
        this.paymentMethod.Value.indexOf('Credit Card') === 0
    }
  },

  data() {
    return {
      uploadFinished: true,
      uploadData: {
        token: this.userToken
      },
      paymentNotes: '',
      referenceNo: '',
      attachment: {},
      costCenter: {},
      paymentMethod: {},
      paidBy: {},
      paidByOptions: [
        { Key: 1, Value: 'Paid by MSP' },
        { Key: 2, Value: 'Paid Outside of MSP' }
      ],
      errors: {
        PaidByMissing: false,
        PaymentMethodMissing: false,
        ReferenceNoMissing: false,
        CostCenterMissing: false
      }
    }
  },

  methods: {
    initEvents() {
      EventBus.$off(Eved.PAYMENT.VALIDATE_POST_PAYMENT_FIELDS + this.divisionKey)
      EventBus.$on(Eved.PAYMENT.VALIDATE_POST_PAYMENT_FIELDS + this.divisionKey, e => {
        this.validate()
      })
    },

    validate() {
      let data = this.getChanges()

      if (this.model.DisplayPaidBy && data.paidBy === '') {
        this.errors.PaidByMissing = true
      } else {
        this.errors.PaidByMissing = false
      }

      // Payment Method
      if (data.paymentMethodId === 0) {
        this.errors.PaymentMethodMissing = true
      } else {
        this.errors.PaymentMethodMissing = false
      }

      // Reference No
      if (data.referenceNo === '') {
        this.errors.ReferenceNoMissing = true
      } else {
        this.errors.ReferenceNoMissing = false
      }

      // Cost Center
      if (data.validateCostCenter && data.costCenterId === 0) {
        this.errors.CostCenterMissing = true
      } else {
        this.errors.CostCenterMissing = false
      }
    },

    selectFirstCostCenter() {
      if (this.model.CostCenters && this.model.CostCenters.length === 1) {
        this.costCenter = this.model.CostCenters[0]
        this.emitChanges()
      }
    },

    paymentMethodChanged(e) {
      this.paymentMethod = e // TODO: remove
      this.emitChanges()
    },

    paidByChanged(e) {
      this.paidBy = e
      this.emitChanges()
    },

    costCenterChanged(e) {
      this.costCenter = e
      this.emitChanges()
    },

    saveAttachment(e) {
      let completedFiles = e.filter(
        item => item.success || // files uploaded with success
        (!item.success && item.response && typeof item.response === 'string' && !utils.json.valid(item.response)) // files where requested failed
      )

      if (completedFiles.length === e.length) {
        this.uploadFinished = true

        this.attachment = e.map(item => {
          let uploadError = ''
          let itemResponse = null

          if (item.success && item.response) {
            itemResponse = JSON.parse(item.response)
            uploadError = (itemResponse && itemResponse.uploadError) ? itemResponse.uploadError : ''
          }
          if (!item.success) {
            uploadError = 'Upload request failed'
          }

          if (uploadError) {
            // TODO: display upload error: 'File "' + item.name + '": ' + uploadError
          } else {
            return {
              AttachmentName: item.name,
              AttachmentSize: item.size,
              AttachmentFile: itemResponse ? itemResponse.file : (item.file || ''),
              AttachmentId: item.id || 0,
              AttachmentPath: itemResponse ? itemResponse.path : ''
            }
          }
        }).shift()
      }

      this.emitChanges()
    },

    getChanges() {
      return {
        divisionOrBUName: this.model.DivisionOrBUName,
        note: this.paymentNotes || '',
        attachment: this.attachment,
        referenceNo: this.referenceNo || '',
        costCenterId: parseInt(this.costCenter && this.costCenter.Key) || 0,
        validateCostCenter: this.displayCostCenters,
        paidBy: (this.paidBy && this.paidBy.Key) || '',
        paymentMethodId: parseInt(this.paymentMethod && this.paymentMethod.Key) || 0
      }
    },

    emitChanges() {
      let data = this.getChanges()

      this.updateValidation(data)

      this.$emit(Eved.PAYMENT.DIVISION_FIELDS_CHANGES, data)
    },

    updateValidation(data) {
      if (data.paymentMethodId > 0) {
        this.errors.PaymentMethodMissing = false
      }
      if ((data.referenceNo || '') !== '') {
        this.errors.ReferenceNoMissing = false
      }
      if (data.validateCostCenter && (parseInt(data.costCenterId) || 0) !== 0) {
        this.errors.CostCenterMissing = false
      }
      if ((data.paidBy || '') !== '') {
        this.errors.PaidByMissing = false
      }
    }

  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/PostPayment.vue